export enum POOL_STATUS {
  NEW = 0,
  ACCEPTED = 1,
  REJECTED = 2,
  FINISHED = 3,
}
